import React from "react";
import TableHeader from "../Common/TableHeader";

function SchoolVendors({vendorTransactionStatus}) {

    return (
        <div className="col-6-xxxl col-lg-6 col-12">
          <div className="card custom-card" style={{ borderRadius: "10px" }}>
            <div className="card-body map-card">
                <div class="heading-layout1 mg-b-25">
                    <TableHeader
                        title="School Vendors"
                        subtitle="List of the school vendors and their transaction status today"
                    />
                    
                </div>

                <div className="border-top mt-3"></div>
                <div className="table-responsive">
                    <table className="table table-hover text-nowrap mg-b-0">
                        <thead>
                            <tr>
                            <th>No.</th>
                            <th>Vendor Name</th>
                            <th>Transactions Today</th>
                            <th>Recent Transaction</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(vendorTransactionStatus) &&
                            vendorTransactionStatus.map((item, key) => (
                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.vendor_name}</td>
                                    <td>{item.transactions_count?.total_p}</td>
                                    <td><span class="badge badge-info">{item.recent_transaction_type}</span><br/><small>{item.created_at}</small></td>
                                
                                </tr>
                            ))}
                            {vendorTransactionStatus === "404" && (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>
                                No vendor transactions today.
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
        </div>
        
    );
}

export default SchoolVendors;
